import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Onboarding'],
  endpoints: (builder) => ({
    // Complete onboarding
    completeOnboarding: builder.mutation({
      query: (onboardingData) => ({
        url: '/onboarding/complete',
        method: 'POST',
        body: onboardingData,
      }),
      invalidatesTags: ['Onboarding'],
    }),

    // Get onboarding status
    getOnboardingStatus: builder.query({
      query: () => '/onboarding/status',
      providesTags: ['Onboarding'],
    }),
  }),
});

export const {
  useCompleteOnboardingMutation,
  useGetOnboardingStatusQuery,
} = onboardingApi;
